import { MultiSelect } from '@carbon/react';

export interface Choice {
  id: string;
  label: string;
}

/** Pick any of several values; the value is comma-separated ids, as the log APIs take them. */
export function MultiChoice({
  id,
  label,
  choices,
  value,
  onChange,
}: {
  id: string;
  label: string;
  choices: Choice[];
  value: string;
  onChange(value: string): void;
}) {
  const chosen = value ? value.split(',') : [];
  return (
    <MultiSelect<Choice>
      id={id}
      titleText={label}
      label={label}
      items={choices}
      itemToString={(o) => o?.label ?? ''}
      selectedItems={choices.filter((c) => chosen.includes(c.id))}
      onChange={({ selectedItems }) => onChange((selectedItems ?? []).map((c) => c.id).join(','))}
      selectionFeedback="fixed"
    />
  );
}
